import type { IPackage, TPackage, TPackageStatus } from "./types";

const getEPSSNumber = (details: IPackage): number => {
  const maxEpss =
    details.advisories?.reduce<number>((max, advisory): number => {
      if (advisory.epss !== null && advisory.epss > max) {
        return advisory.epss;
      }

      return max;
    }, 0) ?? 0;
  const EPSS_MULTIPLIER = 100;

  return maxEpss ? maxEpss * EPSS_MULTIPLIER : 0.0;
};

const getEPSS = (details: TPackage): string => {
  return `${getEPSSNumber(details).toFixed(2)}%`;
};

const getPackageStatus = (details: TPackage): TPackageStatus => {
  const statusArrayWithReachable: TPackageStatus =
    details.vulnerabilityInfo && details.vulnerabilityInfo.length > 0
      ? "REACHABLE"
      : "LATENT";

  return statusArrayWithReachable;
};

export { getEPSS, getEPSSNumber, getPackageStatus };
